import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  BoxContainer,
  BoxHead,
  Underline,
  BoxTitle,
} from "../../Components/Styles/PageStyles";
import SideModal from "../../Components/SideModal";
import NotFoundModel from "../../Components/NotFoundModel";
import { MdAdd, MdChevronRight } from "react-icons/md";
import CreateFolder from "../../Components/Documents/CreateFolder";
import PropertyDocumentUploadModal from "../../Components/Documents/PropertyDocumentModal";
import Loading from "../../Components/Loading";
import DocumentCards from "../../Components/Documents/DocumentCard";
import { AddBtn } from "../../Components/Styles/InputStyles";
import DocumentActionMenu from "../../Components/Documents/DocumentActionMenu";
import EditDocumentModal from "../../Components/Documents/EditName";
import DeleteDocument from "../../Components/Documents/DeleteDocument";

const OwnerDocuments = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [currentPath, setCurrentPath] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
  const [apiData, setApiData] = useState();
  const [isActionOpen, setIsActionOpen] = useState(false);
  // const [deletingId, setDeletingId] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteDocument, setShowDeleteDocument] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 500);

    return () => clearTimeout(handler);
  }, []);

  const fetchFunction = async (folderId) => {
    const response = await axios.get(
      `${Config.apiUrl}/uploadDocument/listfolder`,
      {
        params: {
          folderId,
        },
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );

    return response.data;
  };

  const getSuccess = (res) => {
    if (!res.isSuccess) {
      toast.error(res.msg);
      return;
    }

    setApiData(res.data);
    setCurrentItems(res.data);
  };

  const getError = (res) => {};

  const {
    isLoading: getListLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  //------- Upload Document --------------------------
  const uploadDocumentFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/uploadDocument/uploaddoc`,
      values,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
  };

  const onUploadDocSuccess = (data) => {
    setIsUploadModalOpen(false);

    if (!data?.data?.isSuccess) {
      toast.error(data?.data?.msg || "An Error Occured");
      return;
    }

    if (currentPath.length === 0) {
      // Root
      getListMutate();
    } else {
      // Current opened folder
      const folderId = currentPath[currentPath.length - 1].id;
      getListMutate(folderId);
    }

    toast.success(data.data.msg);
  };

  const onUploadDocError = (data) => {
    setIsUploadModalOpen(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
    uploadDocumentFunction,
    {
      onSuccess: onUploadDocSuccess,
      onError: onUploadDocError,
    },
  );

  //------- Create Folder ------------------------
  const createFolderFunction = async (body) => {
    return await axios.post(
      `${Config.apiUrl}/uploadDocument/createfolder`,
      body,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
  };

  const onCreateFolderSuccess = (data) => {
    if (!data?.data?.isSuccess) {
      toast.error(data?.data?.msg || "An Error Occured");
      return;
    }
    setIsCreateFolderModalOpen(false);
    if (currentPath.length === 0) {
      getListMutate();
    } else {
      const folderId = currentPath[currentPath.length - 1].id;
      getListMutate(folderId);
    }

    toast.success(data.data.msg);
  };

  const onCreateFolderError = (data) => {
    setIsCreateFolderModalOpen(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isCreateLoading, mutate: createFolderMutate } =
    useMutation(createFolderFunction, {
      onSuccess: onCreateFolderSuccess,
      onError: onCreateFolderError,
    });

  const handleActionToggle = () => {
    setIsActionOpen((prev) => !prev);
  };

  const handleUploadClick = () => {
    setIsUploadModalOpen(true);
    setIsActionOpen(false);
  };

  const handleCreateFolderClick = () => {
    setIsCreateFolderModalOpen(true);
    setIsActionOpen(false);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
  };

  const handleCloseCreateFolderModal = () => {
    setIsCreateFolderModalOpen(false);
  };

  // Navigate into a folder
  const handleFolderClick = (folder) => {
    getListMutate(folder.id);
    setCurrentPath([...currentPath, { id: folder.id, title: folder.name }]);
  };

  const formatDate = (date) => {
    if (!date) return "";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  const handleBreadcrumbClick = (index) => {
    if (index === -1) {
      setCurrentPath([]);
      getListMutate();
      return;
    }

    const newPath = currentPath.slice(0, index + 1);
    setCurrentPath(newPath);
    getListMutate(newPath[newPath.length - 1].id);
  };

  const renderBreadcrumb = () => (
    <div className="mt-4 mb-2 flex items-center gap-4">
      <div className="flex items-center flex-wrap text-sm">
        <button
          onClick={() => handleBreadcrumbClick(-1)}
          className={`flex items-center gap-1 text-sm transition ${
            currentPath.length === 0
              ? "font-semibold text-primary-color"
              : "text-gray-600 hover:text-primary-color"
          }`}
        >
          Documents
        </button>

        {currentPath.map((folder, index) => (
          <>
            <MdChevronRight size={18} className="mx-1 text-gray-400" />

            <button
              onClick={() => handleBreadcrumbClick(index)}
              className={
                index === currentPath.length - 1
                  ? "font-semibold text-primary-color"
                  : "font-medium text-gray-600 hover:text-primary-color"
              }
            >
              {folder.title}
            </button>
          </>
        ))}
      </div>

      {/* {currentPath.length > 0 && (
                <button
                    onClick={handleBackClick}
                    className="flex items-center gap-1 rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
                >
                    <MdArrowBack size={18} />
                    Back
                </button>
            )} */}
    </div>
  );

  const { isLoading: isDeleteLoading, mutate: deleteMutate } = useMutation(
    (body) =>
      axios.post(`${Config.apiUrl}/uploadDocument/delete`, body, {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      }),
    {
      // onSuccess: (data) => {
      //   if (!data?.data?.isSuccess) {
      //     toast.error(data?.data?.msg || "An Error Occurred");
      //     return;
      //   }

      //   if (currentPath.length === 0) {
      //     getListMutate();
      //   } else {
      //     getListMutate(currentPath[currentPath.length - 1].id);
      //   }

      //   toast.success(data.data.msg);
      // },

      onSuccess: (data) => {
        if (!data?.data?.isSuccess) {
          toast.error(data?.data?.msg || "An Error Occurred");
          return;
        }

        setShowDeleteDocument(false);
        setSelectedDeleteItem(null);

        if (currentPath.length === 0) {
          getListMutate();
        } else {
          getListMutate(currentPath[currentPath.length - 1].id);
        }

        toast.success(data.data.msg);
      },
      onError: (error) => {
        setShowDeleteDocument(false);
        toast.error(error?.response?.data?.msg || "An Error Occurred");
      },
    },
  );

  // const handleDelete = (item) => {
  //   console.log(item, "delete");
  //   setDeletingId(item.id);

  //   deleteMutate(
  //     {
  //       type: item.type,
  //       id: item.id,
  //     },
  //     {
  //       onSettled: () => setDeletingId(null),
  //     },
  //   );
  // };

  const handleDelete = (item) => {
    setSelectedDeleteItem(item);
    setShowDeleteDocument(true);
  };

  const handleConfirmDelete = () => {
    if (!selectedDeleteItem) return;

    deleteMutate({
      type: selectedDeleteItem.type,
      id: selectedDeleteItem.id,
    });
  };

  //------Edit name option-----------------------------
  const renameFunction = async (body) => {
    return axios.post(`${Config.apiUrl}/uploadDocument/rename`, body, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const { mutate: renameMutate, isLoading: isRenameLoading } = useMutation(
    renameFunction,
    {
      onSuccess: (data) => {
        if (!data.data.isSuccess) {
          toast.error(data.data.msg);
          return;
        }

        setIsEditModalOpen(false);

        if (currentPath.length === 0) {
          getListMutate();
        } else {
          getListMutate(currentPath[currentPath.length - 1].id);
        }

        toast.success(data.data.msg);
      },
      onError: (err) => {
        toast.error(err?.response?.data?.msg || "Something went wrong");
      },
    },
  );

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsEditModalOpen(true);
  };


  return (
    <BoxContainer className="!h-auto">
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Documents
          <Underline />
        </BoxTitle>
        <div className="relative ml-auto">
          <DocumentActionMenu
            isOpen={isActionOpen}
            onUploadClick={handleUploadClick}
            onCreateFolderClick={handleCreateFolderClick}
          />

          <AddBtn onClick={handleActionToggle}>
            <MdAdd
              size={18}
              className={`mr-1 transition-transform ${
                isActionOpen ? "rotate-45" : ""
              }`}
            />
            New
          </AddBtn>
        </div>
      </BoxHead>

      {renderBreadcrumb()}
      {!error && !getListLoading && data && (
        <>
          {!currentItems || currentItems.length === 0 ? (
            <NotFoundModel msg={"No documents or folders found"} />
          ) : (
            <DocumentCards
              currentItems={currentItems}
              handleFolderClick={handleFolderClick}
              formatDate={formatDate}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
            />
          )}
        </>
      )}
      {error && !getListLoading && (
        <NotFoundModel msg="No documents or folders found" />
      )}

      {(getListLoading || isRefetching) && <Loading />}

      <SideModal isOpen={isUploadModalOpen} onClose={handleCloseUploadModal}>
        <PropertyDocumentUploadModal
          handleClose={handleCloseUploadModal}
          uploadDocMutate={uploadDocMutate}
          isDocLoading={isDocLoading}
          currentPath={currentPath}
          folders={apiData || []}
        />
      </SideModal>

      <SideModal
        isOpen={isCreateFolderModalOpen}
        onClose={handleCloseCreateFolderModal}
      >
        <CreateFolder
          handleClose={handleCloseCreateFolderModal}
          createFolderMutate={createFolderMutate}
          isCreateLoading={isCreateLoading}
          currentPath={currentPath}
        />
      </SideModal>

      <SideModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
      >
        <EditDocumentModal
          selectedItem={selectedItem}
          handleClose={() => setIsEditModalOpen(false)}
          renameMutate={renameMutate}
          isRenameLoading={isRenameLoading}
        />
      </SideModal>

      {showDeleteDocument && (
        <DeleteDocument
          setShowDeleteDocument={setShowDeleteDocument}
          selectedData={selectedDeleteItem}
          isDeleteLoading={isDeleteLoading}
          deleteMutate={handleConfirmDelete}
          handleClose={() => {
            setShowDeleteDocument(false);
            setSelectedDeleteItem(null);
          }}
        />
      )}
    </BoxContainer>
  );
};

export default OwnerDocuments;
